<template>
	<div class="account-cont-parent">
		<div class="account">
			<div class="account-info-sec">
				<div class="header5">{{ ownerName }}'s</div>
				<div class="header3">Account</div>
				<!-- <div class="paragraph desktop-text">Click on your case to get more details.</div> -->

				<div class="button-cont" @click="seeCase">
					<i class="material-icons arrow-link">east</i>
					<div class="link-button">Check your case!</div>
				</div>
				<!-- <Button title="Check your case" buttonType="outline" :onClick="seeCase" /> -->

				<!-- @TODO ASK why /orders not giving us anything -->
				<!-- <AccountInfo />
				<CaseResult /> -->
			</div>

			<ResetPassword />
		</div>
		<div class="account-back--cont"></div>
	</div>
</template>

<script>
// @ is an alias to /src
import AccountInfo from "@/components/account/AccountInfo.vue";
import AccountPayments from "@/components/account/AccountPayments.vue";
import Properties from "@/components/account/Properties.vue";
import ResetPassword from "@/components/account/ResetPassword.vue";
import CaseResult from "@/views/CaseResult.vue";

export default {
	name: "account",
	title: "Account",
	components: {
		AccountInfo,
		AccountPayments,
		Properties,
		ResetPassword,
	},
	mounted() {
		window.document.title = "Garbur - Account Page";
	},
	computed: {
		ownerName() {
			return this.$store.getters.getAccountOwnerName;
		},
	},
	methods: {
		seeCase() {
			this.$router.push({ name: "Case" });
		},
	},
};
</script>

<style scoped lang="scss">
.account-cont-parent {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr;
}
.account-back--cont {
	background: var(--dark-blue);
	display: grid;
	grid-column: 1/-1;
	grid-row: 1/-1;
	position: relative;
	width: 100%;
	// height: 500px;
	height: 25rem;
}
.account {
	text-align: left;
	padding: 0 60px;
	padding-top: 60px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(432px, 1fr));
	grid-gap: 20px;
	grid-row: 1/-1;
	grid-column: 1/-1;
	z-index: 3;
	.desktop-text {
		display: block;
	}
	.header5 {
		color: var(--accent);
		padding-bottom: 10px;
	}
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--white);
	}
	.paragraph.desktop-text {
		margin-top: 35px;
		margin: 35px 0;
	}
	.link-button {
		color: var(--accent);
		// margin-top: 8px;
		font-weight: 500;
		font-size: 18px;
		cursor: pointer;
		// border-bottom: 2px solid var(--accent);
		line-height: 30px;
	}

	.arrow-link {
		// background: var(--accent);
		border: 2px solid white;
		color: white;
		border-radius: 20px;
		margin-left: 10px;
		margin-right: 10px;
		padding: 6px;
		cursor: pointer;
	}

	.button-cont {
		text-align: left;
		display: flex;
		margin-top: 50px;
		align-items: center;
	}
	.button-cont:hover {
		.arrow-link {
			border: 2px solid var(--accent);
			color: var(--accent);
		}
		.link-button {
			color: white;
		}
	}
}
@media screen and (max-width: 450px) {
	.account {
		padding: 4rem 1rem;
		grid-template-columns: repeat(auto-fit, minmax(345px, 1fr));
		.desktop-text {
			display: none;
		}
		.header3 {
			margin-bottom: 35px;
		}
	}
}
</style>
